<template>
  <div class="fab_popover">
    <div class="popover_content">
        <div class="list-group">
             <li class="list-group-item" @click="open_service_booking()" style="cursor:pointer">
                <label>Service booking</label>
                <button class="btn btn-md btn-icon btn-pink pull-right">
                    <img src="../assets/images/icons/clipboard_white.svg"> 
                </button>
            </li>
            <!-- <li class="list-group-item">
                <label>Schedule Class</label>
                <button class="btn btn-md btn-icon btn-pink pull-right">
                    <img src="../assets/images/icons/classbooking_white.svg">
                </button>
            </li>
            <li class="list-group-item">
                <label>Product sale </label>
                <button class="btn btn-md btn-icon btn-pink pull-right">
                    <img src="../assets/images/icons/tag_icon.svg">
                </button>
            </li> -->
        </div>

        <button v-on:click="fabClose" class="btn btn-md btn-icon btn-white pull-right point_cursor mt-2"><img src="../assets/images/icons/close_black.svg"></button>
    </div>
  </div>
</template>

<style scoped>
.fab_popover{
    position: fixed;
    z-index: 1000;
    top:0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
}

.list-group-item{
    border: none;
    margin : 0;
    padding: 10px 0;
    background: transparent;
    color: #ffffff;
}

.popover_content{
    position: absolute;
    bottom: 40px;
    right: 114px;
    width: 250px;
}

.list-group-item{
    height: 70px;
    line-height: 56px;
}

li label{
    width: 65%;
    font-weight: bold;
    text-align: right;
    font-size: 20px;
}

.btn-icon{
    border-radius: 50%;
    height: 56px;
    width: 56px;
}

.btn-icon i{
    vertical-align: text-top;
    font-size : 24px;
}
</style>

<script>
export default {
    name: 'popover',
    data(){
        return {
        }
    },
    methods:{
        fabClose() {
            this.$emit('fabPopClose');
        },
        open_service_booking(){
            this.$session.set("staff_selected", false);
            this.$session.set('selected_date',new Date());
            this.$session.set('rebook',false);
            this.$session.remove('staff_id');
            this.$session.remove('service_start_time');
            this.$router.push('/newbooking')
        }

    }
}
</script>